export default "__VITE_ASSET__BqUY85Iv__"